import { Injectable } from '@angular/core';
import { UtilsManager } from 'src/app/managers/utils/utils.manager';
import { NotifierManager } from 'src/app/managers/notifier/notifier.manager';
import { Notifier } from 'src/app/enums/notifier/notifier.enum';
import { NotifierMessage } from 'src/app/enums/notifier/message/notifier.enum';
import { RequestManager } from 'src/app/managers/request/request.manager';
import { ErrorManager } from 'src/app/managers/error/error.manager';
import { User } from 'src/app/beans/login/user/user.bean';
import { Organization } from 'src/app/beans/organization/organization.bean';
import { Result } from 'src/app/beans/result/result.bean';
import { RequestError } from 'src/app/enums/network/request/error/requestError.enum';
import { Site } from 'src/app/beans/site/site.bean';
import { StatisticRequestBean } from 'src/app/beans/request/statistic-request.bean';
import { Statistic } from 'src/app/beans/statistic/statistic.bean';
import { StatisticPeriod } from 'src/app/beans/statistic/statistic.period.bean';

@Injectable({
  providedIn: 'root',
})
export class StatisticHandler {
  constructor(
    private _utils: UtilsManager,
    private _notifier: NotifierManager,
    private _request: RequestManager,
    private _error: ErrorManager,
  ) {}

  async get(token: string, data: StatisticRequestBean) {
    if (!this._utils.checker().isValidText(token)) {
      this._notifier.show(Notifier.WARNING, NotifierMessage.INVALID_PASSWORD);
      return undefined;
    }

    try {
      const response: any = await this._request
        .statistic()
        .get(token, data)
        .toPromise();

      if (!response.success) {
        // MANAGE ERROR
        this._notifier.show(Notifier.ERROR, response.error);
        return undefined;
      }

      return response.data.statistics as StatisticPeriod[];
    } catch (error) {
      // this._error.handleNetwork ( error )
      return undefined;
    }
  }

  async excel(token: string, data: StatisticRequestBean) {
    if (!this._utils.checker().isValidText(token)) {
      this._notifier.show(Notifier.WARNING, NotifierMessage.INVALID_PASSWORD);
      return undefined;
    }

    try {
      const response: any = await this._request
        .statistic()
        .excel(token, data)
        .toPromise();

      return response;
    } catch (error) {
      console.log(error);

      // this._error.handleNetwork ( error )
      return undefined;
    }
  }
}
